import {useQuery} from 'react-query';
import {checkDataDemand} from 'src/services/api/demands';

function useCheckDataDemand(demand) {
  return useQuery(
    ['demand', demand],
    () => checkDataDemand(demand),
    {
      enabled: false, // Disable automatic fetching
    }
  );
}

export default useCheckDataDemand;
